import React from 'react';
// import img from '../images/1234/10.jpg';
const SectionHeader = ({ title, PageLink, Image }) => { 
    return (
        <>
            <header className="header header--bg">
                <div className="header__container">
                    <div className="header__content container" >
                        <h1 data-aos="fade-right" data-aos-duration="1000" data-aos-easing="linear">{title}</h1>
                    </div>
                    <div className="header__container-bg">
                        <img src={Image} alt={Image} />
                    </div>
                </div>
            </header>
        </>
    )
}

export default SectionHeader
